import VuexORM  from '@vuex-orm/core'
//import VuexORMLocalForage from 'vuex-orm-localforage'

const database = new VuexORM.Database()

import Survey from '@/app/models/Survey'
import Respon from '@/app/models/Respon'
import Node  from '@/app/models/master/Node'
import Tps   from '@/app/models/master/Tps'
database.register(Survey)
database.register(Respon)
database.register(Node)
database.register(Tps)

/*VuexORM.use(VuexORMLocalForage, {
  database
})*/

export const vuexorm = VuexORM.install(database)

export default {
  vuexorm
}
